module.exports = __webpack_public_path__ + "static/media/22.fa45164c.jpg";